import MetaFootballModel from "../../Football/Models/Pagination/MetaFootballModel";
import PrivateLeaguePredictionModel from "./PrivateLeaguePredictionModel";

export default class PrivateLeaguePredictionsModel {
  public meta: MetaFootballModel = new MetaFootballModel();
  public data: PrivateLeaguePredictionModel[] = [];
}
